import { t, TFunction } from 'i18next';

export const getNotLoggedInPageTitle = (title: string, t: TFunction) => {
  if (title.includes('/code')) return t('page.title.code');
  switch (title) {
    case '/find-code':
      return t('page.title.findCode');
    case '/sign-in':
      return t('page.title.signIn');
    case '/signup':
      return t('page.title.signUp');
    case '/reset':
      return t('page.title.reset');
    default:
      return '';
  }
};

export const getMediaPageTitle = (title: string, t: TFunction) => {
  switch (title) {
    case 'programme':
      return t('page.title.programme');
    case 'masterclass':
      return t('page.title.masterclass');
    case 'take-actions':
      return t('page.title.takeActions');
    default:
      return t('page.title.media');
  }
};

export const getAssessmentPageTitle = (page: string) => {
  switch (page) {
    case 'AssessmentProfile':
      return t('assessment.page.title.profile');
    case 'PhysicalHealth1':
      return t('assessment.page.title.physicalHealth');
    case 'PhysicalActivity1':
      return t('assessment.page.title.physicalActivity');
    case 'Sleep1':
      return t('assessment.page.title.sleep');
    case 'Stress1':
      return t('assessment.page.title.mentalHealth') + t('assessment.page.title.page', { page: 1 });
    case 'MentalHealth1':
      return t('assessment.page.title.mentalHealth') + t('assessment.page.title.page', { page: 2 });
    case 'MentalHealth2':
      return t('assessment.page.title.mentalHealth') + t('assessment.page.title.page', { page: 3 });
    case 'MentalHealth3':
      return t('assessment.page.title.mentalHealth') + t('assessment.page.title.page', { page: 4 });
    case 'MentalHealth4':
      return t('assessment.page.title.mentalHealth') + t('assessment.page.title.page', { page: 5 });
    case 'MentalHealth5':
      return t('assessment.page.title.mentalHealth') + t('assessment.page.title.page', { page: 6 });
    case 'FinancialWellbeing1':
      return t('assessment.page.title.financialWellbeing');
    case 'Nutrition1':
      return t('assessment.page.title.nutrition');
    case 'Hydration1':
      return t('assessment.page.title.hydration');
    case 'Alcohol1':
      return t('assessment.page.title.alcohol');
    case 'Energy1':
      return t('assessment.page.title.energy') + t('assessment.page.title.page', { page: 1 });
    case 'Energy2':
      return t('assessment.page.title.energy') + t('assessment.page.title.page', { page: 2 });
    case 'Energy3':
      return t('assessment.page.title.energy') + t('assessment.page.title.page', { page: 3 });
    default:
      return '';
  }
};

export const getSignUpPageTitle = (page: number) => {
  switch (page) {
    case 1:
      return t('page.title.signUp1');
    case 2:
      return t('page.title.signUp2');
    case 3:
      return t('page.title.signUp3');
    case 4:
      return t('page.title.signUp4');
    case 5:
      return t('page.title.signUp5');
    default:
      return '';
  }
};
